import { createContext } from 'react';
import { RtcSignaling } from '../util/rtc/signaling';

export const RtcSignalingContext = createContext<{signaling?: RtcSignaling}>({});